import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { startShopifyInstall } from '../utils/shopifyInstall';
import './Landing.css';

const Install: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const [shop, setShop] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const param = new URLSearchParams(window.location.search).get('shop');
    if (param) {
      setShop(param);
      setSubmitting(true);
      startShopifyInstall(param).catch((err) => {
        setError(err?.message || 'Could not start install.');
        setSubmitting(false);
      });
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await startShopifyInstall(shop);
    } catch (err: any) {
      setError(err?.message || 'Could not start install. Please try again.');
      setSubmitting(false);
    }
  };

  return (
    <div className="landing">
      <nav className="landing__nav">
        <Link to="/" className="landing__brand">Shopify Tally Sync</Link>
        <div className="landing__nav-links">
          <Link to="/pricing" className="landing__nav-link">Pricing</Link>
        </div>
      </nav>

      <header className="landing__hero">
        <span className="landing__eyebrow">Install</span>
        <h1>Install Shopify Tally Sync on your store</h1>
        <p>
          Enter your Shopify store URL below. You'll be redirected to Shopify to approve the
          install — it takes about 30 seconds.
        </p>
        <form className="landing__install-form" onSubmit={handleSubmit}>
          <input
            type="text"
            className="landing__install-input"
            placeholder="your-store.myshopify.com"
            value={shop}
            onChange={(e) => setShop(e.target.value)}
            autoComplete="off"
            spellCheck={false}
            disabled={submitting}
          />
          <button
            type="submit"
            className="landing__install-button"
            disabled={submitting || !shop.trim()}
          >
            {submitting ? 'Redirecting…' : 'Continue to Shopify'}
          </button>
        </form>
        <div className="landing__install-hint">
          Free 7-day trial. You can uninstall any time from your Shopify admin.
        </div>
        {error && <div className="landing__install-error">{error}</div>}
      </header>
    </div>
  );
};

export default Install;
